<template>
  <span>
    <div class="background-wallpaper" style="background-image: url(https://res.cloudinary.com/hyimvofxm/image/upload/v1636737932/9_68caa27a4e.png);"></div>
    <FormulateForm class="spaced"  @submit="submitForm">
      <div class="container content">
        <div class="column c12 text-center">
          <h1 class="spaced">BOOK AN ARTIST</h1>
        </div>
        <div class="column c8 push-center" style="padding: 5px">
          <p>
            Please fill the form below as accurately as possible to be able to
            provide with our best artists and rates for your events.
          </p>
          <div class="form-section">
            <h2 class="FormTitle">Who are you?</h2>
            <FormulateInput
              type="text"
              name="fullname"
              v-model="form.fullname"
              label="Full Name"
              validation="required"
              class="form-100"
            />
            <FormulateInput
              type="text"
              name="phone"
              v-model="form.phone"
              label="Phone Number"
              validation="required"
              class="form-50"
            />
            <FormulateInput
              type="email"
              name="email"
              v-model="form.email"
              label="Email Address"
              validation="required|email"
              class="form-50"
            />
          </div>
          <div class="form-section">
            <h2 class="FormTitle">About Your Organisation</h2>
            <FormulateInput
              type="text"
              name="organization"
              v-model="form.organization"
              label="Organizer Official Name"
              validation="required"
              class="form-50"
            />
            <FormulateInput
              type="select"
              label="Where is the Organizer Locatated?"
              validation="required|not:00"
              validation-name="Country"
              name="country"
              v-model="form.country"
              class="form-50"
              :options="countries"
            />
            <FormulateInput
              type="text"
              name="website"
              v-model="form.website"
              label="Official Website"
              validation="url"
            />
          </div>
          <div class="form-section">
            <h2 class="FormTitle">About The Event</h2>
            <FormulateInput
              type="text"
              name="eventTitle"
              v-model="form.eventTitle"
              label="Event Name"
              validation="required"
              validation-name="Event Title"
              class="form-100"
            />
            <FormulateInput
              type="date"
              name="eventstart"
              v-model="form.eventstart"
              label="Event Starting Date"
              validation="required"
              class="form-50"
            />
            <FormulateInput
              type="date"
              name="eventend"
              v-model="form.eventend"
              label="Event Closing Date"
              validation="required"
              class="form-50"
            />
            <FormulateInput
              type="textarea"
              name="info"
              v-model="form.info"
              label="Tell us about your event concept"
              validation="required|max:300"
              class="from-100"
            />
          </div>
          <div class="form-section">
            <h2 class="FormTitle">About The Event</h2>
            <h3 class="FormTitle text-left">
              Please select the artists you want to book ?
            </h3>
          </div>
          <div class="form-section-box">
            <FormulateInput
              :options="this.artists"
              type="checkbox"
              class="optionbox"
              name="artists"
              v-model="form.artists"
            />
          </div>
          <div style="clear: both; height: 32px"></div>
          <FormulateInput type="submit" label="SEND" class="form-50" :disabled='isDisabled'/>
          <FormulateInput type="button" label="RESET" class="form-50" />
        </div>
      </div>
    </FormulateForm>
    <div style="clear: both; height: 50px"></div>
  </span>
</template>
<script>
import axios from 'axios'
import emailjs from 'emailjs-com'

const countries = require('i18n-iso-countries')
countries.registerLocale(require('i18n-iso-countries/langs/en.json'))

export default {
  title: 'Patronus Records - Bookings',
  name: 'CountrySelection',
  computed: {
    countries () {
      var list = countries.getNames('en', { select: 'official' })
      list = Object.keys(list).map((key) => ({ value: list[key], label: list[key] }))
      list.unshift({ value: null, label: 'Choose a Country' })
      return list
    }
  },
  created () {
    axios.get('https://admin.patronusrecords.com/artists').then((response) => {
      response.data.sort(function (a, b) {
        var nameA = a.name.toLowerCase()
        var nameB = b.name.toLowerCase()
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }
        return 0
      })
      response.data = Object.keys(response.data).map((key) => ({
        value: response.data[key].name,
        label: response.data[key].name
      }))
      this.artists = response.data
    })
  },
  data () {
    return {
      isDisabled: false,
      selected: null,
      artists: [],
      form: {
        fullname: null,
        phone: null,
        email: null,
        organizattion: null,
        country: [],
        website: null,
        eventend: null,
        eventstart: null,
        info: null,
        artists: [],
        eventTitle: null
      }
    }
  },
  methods: {
    submitForm () {
      this.isDisabled = true
      this.form.artists = this.form.artists.toString()
      this.form.country = this.form.country.toString()
      axios
        .post('https://admin.patronusrecords.com/bookings', this.form)
        .then((res) => {
          console.log('success')
          emailjs
            .send(
              'service_omqin1f',
              'template_p0x6bz5',
              {
                from_name: this.form.fullname,
                email: this.form.email,
                type: 'Booking',
                message: this.form.eventTitle + '\n\n' + this.form.artists
              },
              'user_rDkovUZ6FIPW5500KTKAa'
            )
            .then(
              (result) => {
                console.log('SUCCESS!', result.text)
                this.$router.push('thankyou')
              },
              (error) => {
                console.log('FAILED...', error.text)
              }
            )
        })
        .catch((error) => {
          console.log('failed', error)
          console.log('failed', error)
          console.log(error.response.data)
          console.log(error.response.status)
          console.log(error.response.headers)
        })
        .finally(() => {
          console.log('what the fuck is finally?')
        })
    }
  }
}
</script>
<style>
.banner {
  width: 100vw;
  /* height: 420px; */
  padding-bottom: 500px;
  display: inline-block;
  vertical-align: top;
  position: relative;
  overflow: hidden;
  background-position: top center;
  background-size: cover;
}
.form-section .formulate-input-label {
  clear: both;
  display: block;
  width: 100%;
  text-transform: uppercase;
  padding-top: 20px;
  margin-bottom: 10px;
}
.form-section input,
.form-section textarea,
.form-section select {
  padding: 15px;
  background-color: #080c1780;
  border: none;
  width: 100%;
  color: white;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 100;
}
.form-section button {
  width: 100%;
  max-width: 300px;
  cursor: pointer;
}
.form-section .formulate-input-error {
  color: red;
  padding: 10px;
}
.form-50 {
  width: 50%;
  padding: 10px;
  float: left;
  text-align: left;
}
.form-100 {
  width: 100%;
  padding: 10px;
  float: left;
  text-align: center;
}
h2.FormTitle {
  background-color: var(--primary);
  padding: 15px;
  border-radius: 11px;
  text-align: left;
  padding-left: 30px;
  clear: both;
  margin-top: 20px;
}
h3.FormTitle {
  padding: 15px;
  border-radius: 11px;
  text-align: left;
  clear: both;
  margin-left: -10px;
  margin-top: 20px;
}
.form-section {
  clear: both;
  margin-top: 20px;
  margin-bottom: 10px;
  overflow: auto;
}

.optionbox input ~ label {
  border: 1px solid var(--secondary);
  display: block;
  width: 20px;
  height: 20px;
  float: left;
  border-radius: 100%;
}
.optionbox input:checked ~ label {
  border: 1px solid green;
  display: block;
}

.optionbox [type="checkbox"],
[type="radio"] {
  display: none;
}
.optionbox .formulate-input-group-item {
  width: 25%;
  padding: 4px;
  float: left;
}
.optionbox .formulate-input-label {
  text-align: left;
  float: left;
  margin-left: 8px;
}
.optionbox input:checked ~ label::after {
  content: " ";
  display: block;
  position: relative;
  background-color: green;
  border-radius: 10px;
  height: 10px;
  width: 10px;
  margin-left: 4px;
  margin-top: 4px;
}
@media only screen and (max-width: 660px) {
  .form-50 {
    width:100%;
  }
  .form-50 button {
    width:100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/booking.vue